import QuestionLayout from "./QuestionLayout";
import AudioPlayButton from "./AudioPlayButton";

export default function AudioTextQuestion({
  config,
  value = {},
  onChange,
  mode = "edit",
  feedback
}) {
  const answers = Array.isArray(value.answers)
    ? value.answers
    : Array(config.items.length).fill("");

  const audioValue = value._audio || {};

  function setAudioState(audioState) {
    if (mode !== "edit") return;

    onChange({
      ...value,
      _audio: audioState
    });
  }

  function setAnswer(i, v) {
    if (mode !== "edit") return;

    const next = [...answers];
    next[i] = v;

    onChange({
      ...value,
      answers: next
    });
  }

  return (
    <QuestionLayout
      number={config.number}
      prompt={config.prompt}
      points={config.points}
      mode={mode}
      feedback={feedback}
    >
      {/* 🔊 AUDIO */}
      {config.audio && (
        <div style={{ marginBottom: 16 }}>
          <AudioPlayButton
            src={config.audio}
            value={audioValue}
            onChange={setAudioState}
            mode={mode}
            maxListens={config.maxListens ?? 1}
          />
        </div>
      )}

      {/* DROPDOWN ANSWERS */}
      <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
        {config.items.map((_, i) => {
          const part = feedback?.parts?.[i];
          const isCorrect = part?.correct;

          return (
            <div
              key={i}
              style={{
                display: "grid",
                gridTemplateColumns: "28px auto",
                alignItems: "center",
                columnGap: 12
              }}
            >
              {/* NUMBER */}
              <div
                style={{
                  fontWeight: 600,
                  fontSize: 16,
                  textAlign: "right"
                }}
              >
                {i + 1}.
              </div>

              {/* SELECT */}
              <select
                value={answers[i] || ""}
                disabled={mode !== "edit"}
                onChange={(e) => setAnswer(i, e.target.value)}
                style={{
                  width: 120,
                  fontSize: 15,
                  padding: "6px 6px",
                  borderRadius: 6,
                  textAlign: "center",
                  border:
                    mode === "review"
                      ? isCorrect
                        ? "2px solid #2e7d32"
                        : "2px solid #c62828"
                      : "1px solid #ccc",
                  background:
                    mode === "review"
                      ? isCorrect
                        ? "#e8f5e9"
                        : "#fdecea"
                      : "white"
                }}
              >
                <option value="">—</option>
                {config.choices.map(choice => (
                  <option key={choice} value={choice}>
                    {choice}
                  </option>
                ))}
              </select>
            </div>
          );
        })}
      </div>
    </QuestionLayout>
  );
}
